import { Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getStaticPageData } from '../../services/StaticPages';
import { useEffect, useMemo, useState } from 'react';
import PublicDetailsForm from './PublicDetailsForm';
import MyTabsNested from '../../components/MyTabsNested';
import { useSelector } from 'react-redux';

const PublicEdit = () => {

  const { slug } = useParams();
  const [pageTitle, setPageTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: () => <div />, subTabs: [
        { id: "basic", title: "Basic", Component: PublicDetailsForm }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (slug) {
          const result = await getStaticPageData(slug);

          if (result) {
            setPageTitle(result?.data?.title);
          }
        }
      } catch (error) {
        console.error('Error fetching static page data:', error);
      }
    };

    getBasicData();
  }, [slug]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    if (!previewEnabled) {
      const pathParts = location.pathname.split('/');
      if (pathParts?.length === 3 && slug) {
        // Redirect to the default tab/subTab
        navigate(`/public/${slug}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
      }
    } else {
      navigate(`/public/${slug}`, {
        replace: true
      });
    }

  }, [location.pathname, slug, navigate, tabs, previewEnabled]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
      <Text fontSize={"16px"} fontWeight={"600"} pt={2}>{pageTitle || 'New Public Page'}</Text>
      {previewEnabled ? <PublicDetailsForm /> : <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/public"} />}
    </Stack>
  );
};

export default PublicEdit;
